module.exports = __webpack_public_path__ + "img/Care2Mobile.2f0526eb.png";